export const BillItemExcelForm = [
  {
    header: {
      header: 'Name',
      width: 17,
    },
    dataType: 'text',
  },
  {
    header: {
      header: 'Description',
      width: 40,
    },
    dataType: 'text',
  },
  {
    header: {
      header: 'TaxSchemeName',
      width: 17,
    },
    dataType: 'text',
  },
  {
    header: {
      header: 'GLAccountCode',
      width: 17,
    },
    dataType: 'text',
  },
  {
    header: {
      header: 'e-Invoice',
      width: 10,
    },
    dataType: 'TrueOrFalse',
  },
  {
    header: {
      header: 'MSICCode',
      width: 17,
    },
    dataType: 'text',
  },
  {
    header: {
      header: 'ClassificationCode',
      width: 17,
    },
    dataType: 'text',
  },
];
